import {Client} from '@stomp/stompjs/esm6';
import {decodeBlob, encodeBlob, Locale} from 'sdv-common';
import {debug, info, retryAfterMillis, wsApi} from '../shared/constants';
import {DealService} from "./deal.service";
import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";

@Injectable({providedIn: 'root'})
export class WebSocketService {

  readonly client: Client;

  constructor(public apiService: ApiService,
              public dealService: DealService) {
    this.client = new Client({
      reconnectDelay: retryAfterMillis,
      brokerURL: wsApi.endpoint,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000
    });

    let _this = this;
    this.client.onConnect = function (frame) {
      _this.addSubscriber((response, headers) => {
        response.response = response.response || {};
        debug('Headers:', headers);

        Array.prototype.concat.apply([], _this.dealService.getGroups().map(g => g.deals))
          .filter(d => {
            d.last_price = response[d.fromToken.contract + '_' + d.toToken.contract] || 0;
            if (d.last_price > 0) {
              d.profit = (d.last_price * d.quantity) - (d.price * d.quantity);
            }
          });
      });
    };

    this.client.onStompError = function (frame) {
      info('Broker reported error: ' + frame.headers['message']);
      info('Additional details: ' + frame.body);
    };

    if (this.apiService.isAuthorized()) {
      this.start();
    }
  }

  addSubscriber(callback, destination: string = wsApi.broker) {
    this.client.subscribe(wsApi.buildSubscriber(destination), function (evt) {
      debug("STOMP Message subscriber:", evt);
      let response = decodeBlob(evt.binaryBody);
      response = JSON.parse(response);
      callback(response, evt.headers);
    });
  }

  send(request, token) {
    debug("STOMP Message publisher:", request);
    if (!this.client.connected) {
      let _this = this;
      setTimeout(() => {
        _this.send(request, token);
      }, 1000);
      return;
    }

    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': Locale.ENGLISH.name
    };
    if (token) {
      headers['Authorization'] = 'Bearer ' + token;
    }

    this.client.publish({
      destination: wsApi.buildPublisher([wsApi.internal.action]),
      binaryBody: encodeBlob(JSON.stringify(request)),
      headers
    });
  }

  start() {
    if (this.client) {
      this.client.activate();
    }
  }

  stop() {
    if (this.client) {
      this.client.deactivate();
    }
  }
}
